// extracted by mini-css-extract-plugin
var _1 = "UpgradeForm_lastFour__zr4FI";
var _2 = "UpgradeForm_ufCard__lnUt4";
var _3 = "UpgradeForm_ufContainer__tzMGr";
var _4 = "UpgradeForm_ufTitle__Wj0oI";
export { _1 as "lastFour", _2 as "ufCard", _3 as "ufContainer", _4 as "ufTitle" }
